import dayjs from "dayjs";
var calendar = require("dayjs/plugin/calendar");
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(calendar);
const obj = {
  currencyFormat: (number = "") => {
    // return new Intl.NumberFormat('en-IN', {}).format(number)
    const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    const formatted = Number(Math.abs(number)).toLocaleString("en-IN", options);
    return formatted;
  },
  dateFormat: (date, timeZone) => {
    // var convertedDate = new Date(date).toLocaleString(undefined, {
    //   timeZone:  "Asia/Dhaka",//timeZone ? timeZone :
    // });

    // return convertedDate.toString();
    return dayjs(date).format("DD-MM-YYYY hh:mm:ss a");
  },
  tdateFormat: (date, timeZone) => {
    // var convertedDate = new Date(date).toLocaleString(undefined, {
    //   timeZone:  "Asia/Dhaka",//timeZone ? timeZone :
    // });
    const convertedDate = new Date(date)
      .toLocaleString(undefined, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
        timeZone: "Asia/Dhaka", //timeZone ? timeZone :
      })
      .replace(",", "")
      .replace(/\//g, "-");
    // console.log("convertedDate",convertedDate.replace(/\//g, "-"))
    return convertedDate.toString();
  },

  msgDateFormat: (date, timeZone) => {
    var convertedDate = new Date(date).toLocaleDateString(undefined, {
      timeZone: timeZone ? timeZone : "Asia/Kolkata",
    });

    return convertedDate.toString();
  },
  matchDateTime: (date, timeZone) => {
    return dayjs(date).calendar(null, {
      sameDay: "h:mm A", // The same day ( Today at 2:30 AM )
      nextDay: "[Tomorrow] h:mm A", // The next day ( Tomorrow at 2:30 AM ) [Tomorrow at] h:mm A
      nextWeek: "DD/MM/YYYY h:mm A", // The next week ( Sunday at 2:30 AM )
      lastDay: "[Yesterday ] h:mm A", // The day before ( Yesterday at 2:30 AM )
      lastWeek: "[Last] dddd h:mm A", // Last week ( Last Monday at 2:30 AM )
      sameElse: "DD/MM/YYYY h:mm A", // Everything else ( 17/10/2011 )
    });
  },
  matchDateTimeNew: (date, timeZone) => {
    return dayjs(date).calendar(null, {
      sameDay: "YYYY-DD-MM",
      nextDay: "YYYY-DD-MM",
      nextWeek: "YYYY-DD-MM",
      lastDay: "YYYY-DD-MM",
      lastWeek: "YYYY-DD-MM",
      sameElse: "YYYY-DD-MM",
    });
  },
  truncateDecimals: (num, digits) => {
    var numS = num?.toString(),
      decPos = numS?.indexOf("."),
      substrLength = decPos == -1 ? numS?.length : 1 + decPos + digits,
      trimmedResult = numS?.substr(0, substrLength),
      finalResult = isNaN(trimmedResult) ? 0 : trimmedResult;

    return parseFloat(finalResult);
  },
};

export default obj;
